import React, { useRef, Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Dialog, Slide as MuiSlide } from '@material-ui/core';

import { Box, SvgIcon } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';
import { useComponentSize } from 'Util/Hooks';

import useFlutterToggleFullscreen from '../Domain/useFlutterToggleFullscreen';

import Slide from './Slide';

const ASPECT_RATIO = 9 / 16;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiSlide direction="up" ref={ref} {...props} />;
});
const DialogLayout = (props) => {
  return (
    <Dialog
      open={true}
      fullScreen={true}
      TransitionComponent={Transition}
      disableBackdropClick
      disableEscapeKeyDown
      {...props}
    />
  );
};

const IconWrapper = styled(Box)`
  cursor: pointer;
`;

const SlideImageWrapper = styled(Box)`
  ${({ isFullscreenSlide, maxSlideWidth }) =>
    isFullscreenSlide &&
    css`
      .react-slideshow-container {
        background: ${getTheme('colors.black')};
        justify-content: center;
        align-items: center;
        height: 100vh;

        img {
          max-width: ${maxSlideWidth ? maxSlideWidth : '100%'};
        }
      }
    `}
`;

const SlideWithFullScreen = ({ slides, syncKey, sliderValue }) => {
  const slideRef = useRef(null);
  const slidePaperSize = useComponentSize(slideRef);
  const [isFullscreenSlide, onOpenFullscreenSlide, onCloseFullscreenSlide] =
    useFlutterToggleFullscreen();
  const Layout = isFullscreenSlide ? DialogLayout : Fragment;

  const MAX_HEIGHT = slidePaperSize?.height ? `${slidePaperSize.height}px` : '100%';

  return (
    <Layout>
      <SlideImageWrapper
        isFullscreenSlide={isFullscreenSlide}
        maxSlideWidth={`calc((1 / ${ASPECT_RATIO}) * ${MAX_HEIGHT})`}
        ref={slideRef}
        width={1}
      >
        <Slide
          slides={slides}
          syncKey={syncKey}
          sliderValue={sliderValue}
          rightControlBarAdornment={
            <IconWrapper>
              <SvgIcon
                icon={
                  isFullscreenSlide
                    ? SvgIcon.ICON_LIST.EXIT_FULL_SCREEN
                    : SvgIcon.ICON_LIST.FULL_SCREEN
                }
                color={'white'}
                size={18}
                onClick={isFullscreenSlide ? onCloseFullscreenSlide : onOpenFullscreenSlide}
              />
            </IconWrapper>
          }
        />
      </SlideImageWrapper>
    </Layout>
  );
};

export default SlideWithFullScreen;
